import React from 'react';
import { useIntl } from 'react-intl';
import { GetServerSidePropsContext } from 'next';

import api from '@services/api';
import { GalleryPage } from '@definitions/galleries.types';
import { GalleryView } from '@components/PLP/galleryView';
import reportError from '@utils/reportError';
import { getPreviewToken, redirectOnError } from '@utils/helpers';
import { Layout } from '@components/layout';

export const getServerSideProps = async ({
  req,
  params = { slug: '' },
}: GetServerSidePropsContext<{ slug: string }>) => {
  try {
    const token = getPreviewToken(req.headers.cookie);

    const { data } = await api.get(`/galleries/${params.slug}`, { headers: { authorization: token } });

    if (!data) {
      return { notFound: true };
    }

    return {
      props: { gallery: data },
    };
  } catch (e) {
    reportError(e);

    return redirectOnError(e);
  }
};

interface SlugProps {
  gallery: GalleryPage;
}

const Slug = ({ gallery }: SlugProps) => {
  const intl = useIntl();
  const headerTitle = intl.formatMessage(
    {
      id: 'gallery.headerTitle',
      defaultMessage: '{title} | Contemporary Art Gallery',
    },
    { title: gallery.title }
  );
  const headerDescription = intl.formatMessage(
    {
      id: 'gallery.headerDescription',
      defaultMessage:
        'Discover new artworks offered by {title}, a leading contemporary art gallery featured on Platform.',
    },
    { title: gallery.title }
  );

  return (
    <Layout title={headerTitle} defaultDescription={headerDescription} seo={gallery.seo}>
      <GalleryView gallery={gallery} />
    </Layout>
  );
};

export default Slug;
